import { AutogenModelEdiRequiredFieldStatus, AutogenRowEdiRequiredFieldStatus } from "./autogen/AutogenModelEdiRequiredFieldStatus";

export class ModelEdiRequiredFieldStatus extends AutogenModelEdiRequiredFieldStatus<RowEdiRequiredFieldStatus> {
	constructor() {
		super(RowEdiRequiredFieldStatus);
	}
}

export class RowEdiRequiredFieldStatus extends AutogenRowEdiRequiredFieldStatus {
}